import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myDate',
    standalone: false
})

export class MyDatePipe implements PipeTransform {
  public transform(input: string | Date): string {
    let date = input as string || null;
    if (date && date.lastIndexOf('Z') != date.length - 1) date = date + 'Z';
    return date;
  }
}
